import styled from 'styled-components';
import { spacing } from '../style/theme';
var ContentContainer = styled.div.withConfig({
  displayName: "ContentContainer",
  componentId: "l04jq2-0"
})(["position:relative;max-width:", ";margin:0 auto;text-align:", ";@media only screen and (max-width:1024px){padding-left:24px;padding-right:24px;}"], function (_ref) {
  var width = _ref.width;
  return width || spacing.containerWidth + "px";
}, function (_ref2) {
  var centered = _ref2.centered;
  return centered ? 'center' : null;
});
export default ContentContainer;